import 'angular:locale/data:de';
import './apps/klug-tool/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
